/**
 * Browser OTEL SDK setup for the shell SPA.
 *
 * Humble object — only calls OTEL SDK constructors and register().
 * No branching logic. Validated by manual browser testing, not unit tests.
 */
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { W3CTraceContextPropagator } from '@opentelemetry/core';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';

export function initBrowserTelemetry(dpId: string, otlpEndpoint?: string): void {
  // Use a relative /otlp/ path by default — nginx proxies to the in-cluster
  // collector. An explicit endpoint overrides this (e.g., for local dev).
  const baseUrl = otlpEndpoint || '/otlp';
  const exporter = new OTLPTraceExporter({
    url: `${baseUrl}/v1/traces`,
  });

  const resource = resourceFromAttributes({
    'zion.data_plane.id': dpId,
    'service.name': 'shell',
  });

  const provider = new WebTracerProvider({
    resource,
    spanProcessors: [new BatchSpanProcessor(exporter)],
  });

  provider.register({ propagator: new W3CTraceContextPropagator() });

  registerInstrumentations({
    instrumentations: [
      new FetchInstrumentation({ propagateTraceHeaderCorsUrls: [/.*/] }),
      new XMLHttpRequestInstrumentation(),
    ],
  });
}
